import { create } from "zustand";

type DebugState = {
    isDebugEnabled: boolean;
    isSettingUpLighting: boolean;

    setIsSettingUpLighting: (isSettingUpLighting: boolean) => void;
    setIsDebugEnabled: (isDebugEnabled: boolean) => void;
};

export const useDebugState = create<DebugState>((set) => ({
    isDebugEnabled: false,
    isSettingUpLighting: false,

    setIsSettingUpLighting: (isSettingUpLighting: boolean) => set({ isSettingUpLighting }),
    setIsDebugEnabled: (isDebugEnabled: boolean) => set({ isDebugEnabled }),
}));
